import { useTranslation } from "react-i18next";
import BillingMessage from "../components/billing-message";
import NotificationSetting from "../components/notification-setting";
import { NotificationTabType } from "../constants";
import { useNotificationStore } from "../store/notification-store";

export function useGetTabsList() {
  const { currentNotificationTab } = useNotificationStore();
  const { t } = useTranslation("notification");
  const currentTabsList = [
    {
      label: t("notification_billing_message"),
      key: NotificationTabType.BillingMessage,
      children: <BillingMessage />,
    },
    {
      label: t("notification_appeal_billing_message"),
      key: NotificationTabType.AppealBillingMessage,
      children: <BillingMessage />,
    },
    {
      label: t("notification_billing_tab_message_notification"),
      key: NotificationTabType.NotificationSetting,
      children: <NotificationSetting />,
    },
  ];
  return {
    tabsList: currentTabsList,
    currentNotificationTab,
  };
}
